import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/products' },
    { label: 'Industries', path: '/industries' },
    { label: 'Quality Standards', path: '/quality' }
  ];

  const productLinks = [
    'Clear Zebra Hose',
    'Clear Color Hose',
    'Nylon Hose',
    'Gas Pipes'
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">
                Golden Plastic
              </h3>
              <p className="text-sm text-slate-400">Industries</p>
            </div>
            <p className="text-sm leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="hover:text-orange-400 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Our Products</h4>
            <ul className="space-y-3">
              {productLinks.map((product, index) => (
                <li key={index}>
                  <Link
                    to="/products"
                    className="hover:text-orange-400 transition-colors duration-200 text-sm"
                  >
                    {product}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-orange-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm">{companyInfo.phone[0]}</p>
                  <p className="text-sm">{companyInfo.phone[1]}</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-orange-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm">{companyInfo.email}</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-orange-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm">{companyInfo.address}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="text-center">
            <p className="text-sm text-slate-400">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
